<div class="flex justify-between align-middle">
	<h3 class="mb-5">New Invitation!</h3>
</div>

<div class="flex flex-col px-48">
	<ng-container>
		<span class="flex justify-center items-center my-2 w-full">
			<img
				src="/assets/images/auth/new-account-invite.svg"
				alt="New Invitation"
				class="w-auto mb-5"
			/>
		</span>
		<div class="flex">
			<h4>Invitation to join {{ data.invite.businessName }}</h4>
		</div>
		<div class="text-grey text-sm mb-4">
			You have been invited to join {{ data.invite.businessName }}. Please
			review the details below and choose to accept the invitation or reject it.
		</div>
		<div class="flex mb-4">
			<p class="text-base font-bold">Business Name:&nbsp;</p>
			<p class="text-base">{{ data.invite.businessName }}</p>
		</div>
		<div class="flex mb-4">
			<p class="text-base font-bold">Invited By:&nbsp;</p>
			<p class="text-base">{{ data.invite.createdByName }}</p>
		</div>
		<div class="flex mb-4">
			<p class="text-base font-bold">Email:&nbsp;</p>
			<p class="text-base">{{ data.invite.createdByEmail }}</p>
		</div>
		<div class="flex mb-4">
			<p class="text-base font-bold">Invitation Date:&nbsp;</p>
			<p class="text-base">
				{{
					DateToBusinessShortDate(data.invite.createdAt, ShortDateFormat.FIVE)
				}}
			</p>
		</div>
	</ng-container>
</div>

<div class="flex items-center justify-end items mt-14">
	<div class="flex items-center gap-2">
		<app-button btn="border" (click)="declineInvite()">Decline</app-button>
		<app-button btn="primary" (click)="acceptInvite()"
			>Accept Invite</app-button
		>
	</div>
</div>
